/* eslint-disable react/forbid-prop-types */
import 'url-search-params-polyfill';

import React, { useState } from 'react';
// useState

import { Tabs, Button } from 'antd';

import ProductTab from '../../../components/DibbsTabs/productTab';

const { TabPane } = Tabs;

const Header = block => {
  const { data } = block;
  console.log(data);
  const [activeKey, setActiveKey] = useState('0');

  const onTabChange = newKey => {
    if (newKey) setActiveKey(newKey);
  };
  const onButtonClick = (forward, location) => {
    let change = 0;
    if (forward) {
      change = 1;
    } else {
      change = -1;
    }
    const activeNum = Number(activeKey) + change;
    console.log(location);
    console.log(data.values[activeNum]);
    if (data.values[activeNum]) {
      setActiveKey(activeNum.toString());
    } else {
      data.changeMenus(location);
    }
  };

  const tabBuilder = () =>
    data.values.map((value) => (
      <TabPane tab={`${value.nsnOrPn}`} key={`tab-${value.nsnOrPn}`}>
        <ProductTab
          values={value}
          changeValues={(key, value1) => {
            data.changeValues(key, value1, data.values.findIndex(v => v.nsnOrPn === value.nsnOrPn));
          }}
          quoteValues={data.quoteValues}
          changeQuoteValues={data.changeQuoteValues}
        />
      </TabPane>
    ));

  return (
    <div className="subcomponent-wrapper">
      <div className="subcomponent-header">Product</div>
      {/* <div className="subcomponent-subheader">Pricing & Delivery</div> */}
      <Tabs activeKey={activeKey} onChange={onTabChange}>
        {tabBuilder()}
      </Tabs>
      <div className="wizard-button-wrapper">
        <Button
          onClick={() => {
            onButtonClick(false, 'priceBreaks');
          }}
        >
          Previous
        </Button>
        <Button
          onClick={() => {
            onButtonClick(true, 'review');
          }}
          type="primary"
        >
          Next
        </Button>
      </div>
    </div>
  );
};

export default Header;



// WEBPACK FOOTER //
// ./src/pages/DibbsRfq/subcomponents/DibbsProduct.jsx